import { SearchInspirationType } from '..'

export const groupAndParseInspirations = (
  inspirationsArray: SearchInspirationType[],
): SearchInspirationType[] => {
  if (inspirationsArray.length === 0) return []

  const groupedInspirations = inspirationsArray.reduce<
    Record<string, SearchInspirationType[]>
  >((accumulator, inspiration) => {
    const { department } = inspiration
    if (!accumulator[department]) {
      accumulator[department] = []
    }
    accumulator[department].push(inspiration)
    return accumulator
  }, {})

  const cards = groupedInspirations.ALL_CARDS || []
  const gifts = groupedInspirations.ALL_GIFTS || []
  const flowers = groupedInspirations.ALL_FLOWERS_AND_PLANTS || []

  const result = [...cards, ...gifts, ...flowers]

  return result
}
